import { useEffect } from 'react';
import { focusManager } from 'react-query';

// fix for an issue when using a file input when you don't want to refresh queries after refocus
// https://github.com/TanStack/query/issues/2960

export default function useDisableRefetchOnFocus(): void {
  useEffect(() => {
    focusManager.setFocused(false);
    return () => focusManager.setFocused(undefined);
  }, []);
}
